var link_viewer_default = {
  "fontElementMap": "vUNzW",
  "link": "vNPZG",
  "linkInEditor": "_8n0qz",
  "linkInViewer": "a37RS",
  "toolbarUrlContainer": "OZ2iW",
  "toolbarUrl": "BMEYm",
  "toolbarUrlAnchor": "sqLo3"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
